module.exports = __webpack_public_path__ + "img/forestgreen@2x.2a4d42d.jpg";